module.exports = __webpack_public_path__ + "img/pattern-icon-1.a885e006.png";